import { createActionTypes } from 'sdk/base';


export const sliceName = 'globalConfigApi';
export const BE_PREFIX = 'graphql';
export const TESTING_ENDPOINTS_RGX = /^((https?:\/\/)?(ilcepoc|inlnqw|illnqw|localhost))/;
export const ActionTypes = createActionTypes([
    'UPDATE_BASE_URL',
    'CLEAR_API_ERROR',
    'UPDATE_API_ERROR',
    'UPDATE_TENANT_ID',
    'SET_SPINNER_VISIBILITY',
    'UPDATE_SESSION_AUTH',
    'UPDATE_ERROR_STATE',
    'CLEAN_ERROR_STATE',
    'UPDATE_SESSION_ID'
]);

const config = {
    sliceName
};

export default config;
